import { useEffect, useRef, useState } from "react";
import { api } from "../api.js";

// Один ресурс дашборда: власні loading/error, попередні дані лишаються видимими під час
// оновлення (updating). url = null — не завантажувати. reload — будь-яке значення, зміна
// якого перезавантажує ресурс (наприклад, версія після синку)
export function useResource(url, reload) {
  const [state, setState] = useState({ data: undefined, error: null, loading: Boolean(url) });
  const seq = useRef(0);
  useEffect(() => {
    if (!url) { seq.current++; setState((s) => (s.loading ? { ...s, loading: false } : s)); return; }
    const n = ++seq.current;
    setState((s) => ({ ...s, loading: true }));
    api(url).then(
      (data) => { if (n === seq.current) setState({ data, error: null, loading: false }); },
      (error) => { if (n === seq.current) setState((s) => ({ data: s.data, error, loading: false })); },
    );
  }, [url, reload]);
  // url щойно з'явився (було null): ефект ще не запустив запит, але це вже «завантажується», а не «порожньо»
  const loading = state.loading || (Boolean(url) && state.data === undefined && !state.error);
  return {
    ...state,
    loading,
    // Перше завантаження ще триває — даних немає
    pending: loading && state.data === undefined,
    updating: loading && state.data !== undefined,
  };
}

// Дані розділу застаріли: успішного оновлення не було понад добу
export const STALE_MS = 24 * 3600e3;
export const isStale = (res, now = Date.now()) =>
  Boolean(res?.lastSuccessAt) && now - new Date(res.lastSuccessAt).getTime() > STALE_MS;
